import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/api/client.js";
import { PhotoLightbox } from "@/components/PhotoLightbox.jsx";
import { useOrignalUi } from "@/hooks/useOrignalUi.js";

export function SouvenirsPage() {
  const { ui } = useOrignalUi();
  const t = ui.hunt;
  const [data, setData] = useState(null);
  const [pack, setPack] = useState({ messages: [], photos: [] });
  const [index, setIndex] = useState(-1);

  useEffect(() => {
    api("/api/bootstrap").then(setData).catch(() => {});
    api("/api/prospection/souvenirs").then(setPack).catch(() => {});
  }, []);

  const photos = (pack.photos || []).length ? pack.photos : (data?.hunt?.photos || []);
  const anecdotes = pack.messages || [];
  const meals = photos.filter((p) => ["repas", "nourriture"].includes(p.category));
  const group = photos.filter((p) => p.category === "groupe");
  const vehicles = photos.filter((p) => p.category === "vehicule");

  return (
    <main className="og-home og-home--chapter" data-testid="page-souvenirs">
      <section className="og-panel">
        <p className="og-kicker">{t.ourProspect}</p>
        <h1>{t.nosSouvenirs}</h1>
        <p>{t.souvenirsLead}</p>
        <Link className="og-btn" to="/chasse-2026/prospection">{t.openProspect}</Link>
      </section>
      <section className="og-panel">
        <p className="og-kicker">{t.ourPhotos}</p>
        {photos.length ? (
          <div className="og-home__mosaic og-home__mosaic--wide">
            {photos.map((p, i) => (
              <button key={p.id} type="button" className="og-home__shot" style={{ backgroundImage: `url(${p.thumb_url || p.url})` }} onClick={() => setIndex(i)} aria-label={p.caption || t.ourPhotos} />
            ))}
          </div>
        ) : (
          <p className="og-hint">{t.noPhotos}</p>
        )}
      </section>
      {anecdotes.length ? (
        <section className="og-panel" data-testid="souvenir-notes">
          <p className="og-kicker">{t.anecdotes}</p>
          {anecdotes.slice(0, 12).map((i) => (
            <article key={i.id} className="og-fb-hist">
              <small>{i.author}</small>
              <p>{i.title || i.body}</p>
            </article>
          ))}
        </section>
      ) : null}
      {meals.length ? <p className="og-hint">{t.meals}: {meals.length}</p> : null}
      {group.length ? <p className="og-hint">{t.groupShots}: {group.length}</p> : null}
      {vehicles.length ? <p className="og-hint">{t.vehicleShots}: {vehicles.length}</p> : null}
      {index >= 0 ? (
        <PhotoLightbox items={photos} index={index} onIndex={setIndex} onClose={() => setIndex(-1)} ui={ui} />
      ) : null}
    </main>
  );
}
